import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronDown = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props} data-testid="chevron-down">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.0605 15.0607L32.9392 12.9394L20.9999 24.8787L9.06055 12.9394L6.93923 15.0607L20.9999 29.1213L35.0605 15.0607Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronDown
